var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isHiddenRECAPTCHA)?_c('vue-recaptcha',{ref:"recaptcha",attrs:{"size":"invisible","sitekey":_vm.secretKeyRECAPTCHA,"badge":"bottomleft"},on:{"verify":_vm.verify,"render":_vm.validateRECAPTCHA}}):_vm._e(),(_vm.isShowLayout)?_c('Layout'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }